// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1FG28","upload":"Small_upload__lnlUA","imageWrap":"Small_imageWrap__3OQvm","removeBtn":"Small_removeBtn__2od5O"};